import { ENUMS } from '../utils/constants';

const INITIAL_STATE = {
    areas: [],
    orderGroup: {},
    almox: undefined,
    orders: {
        hasNextPage: false,
        hasPreviousPage: false,
        indexFrom: 0,
        items: [],
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
        totalPages: 0
    },
    order: {},
    orderReceived: {
        order: {},
        showModalReceivedOrder: false,
        noHasGroup: false,
        updateListMission: false
    },
    mission: {},
    filter: {
        mdrTypeList: [],
        sectors: [],
        areas: [],
        allOrders: true,
        orderCode: undefined,
        routeCode: undefined,
        auxCode: undefined,
        cim: undefined,
        partnumber: undefined,
        supplierCode: undefined,
        orderType: ENUMS.eOrderType.Lowering,
        routeId: undefined,
        lockedBy: undefined,
        excludeOrderGrouped: true,
        assigned: false,
        status: [ENUMS.eOrderStatus.Waiting.value, ENUMS.eOrderStatus.InProgress.value,
        ENUMS.eOrderStatus.WaitingRouteComposition.value
        ],
        orderItemCode: undefined,
        position: [],
        routes: []
    },
    transmissions: [],
    transmission: {},
    pduLocationTargetPaged: {},
    pduLocationTarget: {}
};

export default function loweringReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {
        case 'SET_TRANSMISSIONS':
            return {
                ...state,
                transmissions: action.transmissions,
            }
        case 'SELECT_TRANSMISSION':
            return {
                ...state,
                transmission: action.transmission,
            }
        case 'LOWERING_FILTER':
            return {
                ...state,
                filter: action.filter,
            };
        case 'LOWERING_SELECT_ORDER_GROUP':
            return {
                ...state,
                orderGroup: action.orderGroup,
            };

        case 'LOWERING_FILTER_ALMOX':
            return {
                ...state,
                almox: action.almox,
            };
        case 'RESET_ORDER_GROUP':
            return {
                ...state,
                orderGroup: INITIAL_STATE.orderGroup
            };
        case 'LOWERING_ORDERS':
            return {
                ...state,
                orders: action.orders,
            };
        case 'LOWERING_SELECT_ORDER':
            return {
                ...state,
                order: action.order,
            };
        case 'LOWERING_SELECT_MISSION':
            return {
                ...state,
                mission: action.mission,
            };
        case 'UPDATE_LOWERING_MISSION_STATUS': {
            const order = state.order;
            const missionUpdate = order.items.find((m) => m.orderItemId === action.orderItemId);
            if (missionUpdate) {
                missionUpdate.status = action.status;
            }
            return {
                ...state,
                order
            };
        }
        case 'UPDATE_LOWERING_ORDER_STATUS': {
            const orderUpdate = state.order;
            orderUpdate.status = action.status;

            const orders = state.orders;
            const orderAux = orders.items.find((o) => o.orderId === action.orderId);
            if (orderAux) {
                orderAux.status = action.status;
            }

            return {
                ...state,
                orderUpdate,
                orders
            };
        }
        case 'RESET_LOWERING_ORDER':
            return {
                ...state,
                order: INITIAL_STATE.order
            };
        case 'LOWERING_UPDATE_ORDER': {
            const orders = state.orders;

            const order = orders.items.find((o) => o.orderId === action.order.orderId);
            if (order) {
                if (action.order.status !== ENUMS.eOrderStatus.Canceled.value
                    && action.order.status !== ENUMS.eOrderStatus.Finished.value
                    && action.order.status !== ENUMS.eOrderStatus.ManuallyFinished.value) {
                    Object.assign(order, action.order);
                } else {
                    orders.items = orders.items.filter((o) => o.orderId !== action.order.orderId);
                    orders.totalCount -= 1;
                }
            }
            return {
                ...state,
                orders
            };
        }
        case 'LOWERING_UNBLOCK_ORDER': {
            const orders = state.orders;
            const order = orders.items.find((o) => o.orderId === action.orderId);
            if (order) {
                order.status = ENUMS.eOrderStatus.Waiting.value;
                order.startedBy = '';
                order.startedOn = '';
            }
            return {
                ...state,
                orders
            };
        }
        case 'LOWERING_REMOVE_ORDER': {
            const orders = state.orders;
            const orderRemove = [];
            const orderGroupRemove = {};

            try {
                const order = orders.items.find((o) => o.orderId === action.orderId);
                if (order) {
                    orders.items = orders.items.filter((o) => o.orderId !== action.orderId);
                }

                const orderGroupUpdate = state.orderGroup;
                if (orderGroupUpdate?.orders) {
                    const orderFromGroup = orderGroupUpdate?.orders.find((o) => o.orderId === action.orderId);
                    if (orderFromGroup) {
                        orderGroupUpdate.orders = orderGroupUpdate.orders.filter((o) => o.orderId !== action.orderId);
                    }
                }
                Object.assign(orderRemove, orders);
                Object.assign(orderGroupRemove, orderGroupUpdate);

                return {
                    ...state,
                    orders: orderRemove,
                    orderGroup: orderGroupRemove
                };
            } catch (error) {
                return {
                    ...state
                };
            }
        }
        case 'RESET_LOWERING_FILTER': {
            return {
                ...state,
                filter: {
                    orderCode: undefined,
                    cim: undefined,
                    auxCode: undefined,
                    partnumber: undefined,
                    supplierCode: undefined,
                    orderType: undefined,
                    routeId: undefined,
                    routeCode: undefined,
                    lockedBy: undefined,
                    excludeOrderGrouped: true,
                    allOrders: undefined,
                    orderItemCode: undefined,
                    status: [ENUMS.eOrderStatus.Waiting.value, ENUMS.eOrderStatus.InProgress.value,
                    ENUMS.eOrderStatus.WaitingRouteComposition.value,
                    ],
                    position: [],
                    routes: [],
                    mdrTypeList: []
                }
            };
        }
        case 'RESET_LOWERING_ORDERS': {
            return {
                ...state,
                orderGroup: {},
                orders: {
                    hasNextPage: false,
                    hasPreviousPage: false,
                    indexFrom: 0,
                    items: [],
                    pageIndex: 0,
                    pageSize: 10,
                    totalCount: 0,
                    totalPages: 0
                },
                order: {},
                mission: {},
                transmissions: [],
                transmission: {},
            };
        }
        case 'LOWERING_CHANGEUSER_ORDER': {
            const orders = state.orders;

            const order = orders.items.find((o) => o.orderId === action.orderId);
            order.startedBy = action.newUser;
            order.startedOn = new Date().toISOString();

            return {
                ...state,
                orders
            };
        }
        case 'LOWERING_PICKING_ADD_ORDER': {
            const orders = state.orders;
            const order = orders.items.find((o) => o.orderId === action.order.orderId);
            if (!order) {
                orders.items.push(action.order);
            }

            return {
                ...state,
                orders
            };
        }
        case 'SET_AREAS':
            return {
                ...state,
                areas: action.areas,
            };
        case 'SET_SECTORS':
            return {
                ...state,
                sectors: action.sectors,
            };
        case 'LOWERING_ORDER_RECEIVED':
            const newOrderReceived = {}
            Object.assign(newOrderReceived, action.orderReceived);
            return {
                ...state,
                orderReceived: newOrderReceived,
            };
        case 'SET_PDU_LOCATION_TARGET_PAGED':
            const newpduLocationTargetPaged = {}
            Object.assign(newpduLocationTargetPaged, action.pduLocationTargetPaged);
            return {
                ...state,
                pduLocationTargetPaged: newpduLocationTargetPaged,
            };
        case 'SET_PDU_LOCATION_TARGET':
            const newpduLocationTarget = {}
            Object.assign(newpduLocationTarget, action.pduLocationTarget);
            return {
                ...state,
                pduLocationTarget: newpduLocationTarget,
            };
        default:
            return state;
    }
}
